export class Firmware {
    constructor(
        public id: string,
        public name: string,
        public major: number,
        public minor: number,
        public revision: string
    ) { }
}
export class PaginationInfo {
    constructor(
        public count: number,
        public total: number,
        public hasNextPage: boolean,
        public hasPreviousPage: boolean,
        public startCursor: string | null,
        public endCursor: string | null
    ) { }
}

